import {
  createStore
} from 'vuex'

const store = createStore({
  state() {
    return {
      userInfo: null,
      currentClass: null,
    }
  },
  mutations: {
    userInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    currentClass(state, currentClass) {
      state.currentClass = currentClass;
    }
  },
  actions: {},
  modules: {}
})

export default store